import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

enum LeadGeneratorGTMEvent {
    CPL_MODAL = "cpl_modal"
}

export enum LeadGeneratorAction {
    MODAL_CLOSE = "modal_close",
    AGREEMENT_OFF = "agreement_off",
    SHOW_MORE_OFFERS = "show_more_offers",
    GALLERY_ARROW_CLICK = "gallery_arrow_click",
    VIEW = "view"
}

export const hitGtmLeadGenerator = (action: LeadGeneratorAction) => {
    hitGoogleTagManager({
        event: LeadGeneratorGTMEvent.CPL_MODAL,
        cpl_action: action
    });
};
import {hitGoogleTagManager} from "../../tracking/google_tag_manager/init_google_tag_manager";

enum LeadGeneratorGTMEvent {
    CPL_MODAL = "cpl_modal"
}

export enum LeadGeneratorAction {
    MODAL_CLOSE = "modal_close",
    AGREEMENT_OFF = "agreement_off",
    SHOW_MORE_OFFERS = "show_more_offers",
    GALLERY_ARROW_CLICK = "gallery_arrow_click",
    VIEW = "view"
}

export const hitGtmLeadGenerator = (action: LeadGeneratorAction) => {
    hitGoogleTagManager({
        event: LeadGeneratorGTMEvent.CPL_MODAL,
        cpl_action: action
    });
};
